"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants = __importStar(require("./constants"));
const constants_1 = require("./constants");
const utils_1 = require("../utils");
class SearchBuilder {
    constructor(props) {
        this.props = props;
    }
    getPropertyField(property) {
        const target = property[constants.GuiTarget];
        const field = property[constants.GuiVariable] || property[constants.GuiTarget];
        return property[constants.GuiRange][constants._id] === 'xsd:string'
            ? !target.endsWith(constants._type) && !target.endsWith(constants._id)
                ? `k:${field}`
                : field
            : field;
    }
    getStateFilterValues(property, useDefaultValues) {
        var _a, _b, _c;
        const showAny = !!property[constants.GuiShowAnyOption];
        const filterValues = ((_b = (_a = this.props.states.filters) === null || _a === void 0 ? void 0 : _a[property[constants.GuiTarget]]) !== null && _b !== void 0 ? _b : []).filter(p => p !== '');
        const defaultValues = (_c = property[constants.GuiDefaultValues]) !== null && _c !== void 0 ? _c : [];
        const values = useDefaultValues
            ? (0, utils_1.coalesceEmptyArray)(defaultValues, filterValues)
            : (0, utils_1.coalesceEmptyArray)(filterValues, defaultValues);
        const options = (property[constants.GuiValues] || []).map(o => o[constants.GuiOptionKey]);
        return showAny && values.includes(constants_1.SEARCH_ANY_OPTION_KEY) ? options : values;
    }
}
exports.default = SearchBuilder;
